import { render, staticRenderFns } from "./OrdreEixidaCreateNOLL.vue?vue&type=template&id=b60e8566&scoped=true"
import script from "./OrdreEixidaCreateNOLL.vue?vue&type=script&lang=js"
export * from "./OrdreEixidaCreateNOLL.vue?vue&type=script&lang=js"
import style0 from "./OrdreEixidaCreateNOLL.vue?vue&type=style&index=0&id=b60e8566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60e8566",
  null
  
)

export default component.exports